export const fr = {
  siteName: 'Épitrousse'
};
